define("settings/templates/application", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _templateFactory.createTemplateFactory)({
    "id": "V3G/z4yo",
    "block": "[[[10,0],[14,0,\"o--page\"],[12],[1,\"\\n  \"],[8,[39,0],null,null,null],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--page__push\"],[12],[13],[1,\"\\n\\n  \"],[10,\"main\"],[14,0,\"o--page__content tAC--content\"],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@route\"],[\"overview\"]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"o--container tAC--container\"],[12],[1,\"\\n      \"],[46,[28,[37,3],null,null],null,null,null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"navigation-sidebar\",\"shared/trial-countdown\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/application.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});